export const MenuIdHome = 'HOME' as const;
